


















































































































































import { Component as VueComponent } from 'vue';
import { Component, Mixins, Prop, Ref } from 'vue-property-decorator';
import { CreateCounterData } from '@/modules/backend/Dto/CreateCounterData';
import { namespace } from 'vuex-class';
import { Resources } from '@/modules/backend/Resources/Resources';
import { Model } from '@/modules/backend/Entities/Model';
import EditDialogWrapper from '@/layouts/EditDialogWrapper.vue';
import Mixin from '@/mixins/base';
import { ValidationObserver } from '@/plugins/vee-validate';

const ResourceModule = namespace('dashboard/resources');
const ModelModule = namespace('dashboard/models');
const CounterModule = namespace('dashboard/counters');

type VDialog = VueComponent & {
  save: (value: string | Date) => void;
};

@Component({
  mixins: [Mixin],
  components: {
    'edit-dialog-wrapper': EditDialogWrapper
  }
})
export default class CounterAddDialog extends Mixins(Mixin) {
  @Prop({ required: true })
  private readonly accountId!: number;

  @Ref('observer')
  private readonly observer!: ValidationObserver;

  @ResourceModule.Action('Fetch')
  private readonly fetchResources!: () => Promise<void>;

  @ModelModule.Action('Fetch')
  private readonly fetchModels!: () => Promise<void>;

  @ResourceModule.Getter('Resources')
  private readonly resources!: Resources[];

  @ModelModule.Getter('Models')
  private readonly models!: Model[];

  @CounterModule.Action('Create')
  private readonly createCounter!: (data: CreateCounterData) => Promise<void>;

  private form: CreateCounterData = new CreateCounterData({
    initialValue: 0,
    channel: 0,
    serialNumber: {
      counter: '',
      device: ''
    },
    accountId: this.accountId,
    modelId: -1,
    resourceId: -1,
    note: '',
    checkInterval: {
      /* eslint-disable @typescript-eslint/no-magic-numbers */
      last: new Date().toISOString().substr(0, 10),
      next: new Date().toISOString().substr(0, 10)
      /* eslint-enable @typescript-eslint/no-magic-numbers */
    },
    stamp: ''
  });

  private pickers = {
    next: false,
    last: false
  };

  @Ref() readonly dateFromPicker!: VDialog;

  @Ref() readonly dateToPicker!: VDialog;

  private clearForm(): void {
    this.form.initialValue = 0;
    this.form.channel = 0;
    this.form.serialNumber.counter = '';
    this.form.serialNumber.device = '';
    this.form.accountId = this.accountId;
    this.form.modelId = 0;
    this.form.note = '';
    this.form.resourceId = 0;
    this.form.note = '';
    /* eslint-disable @typescript-eslint/no-magic-numbers */
    this.form.checkInterval.last = new Date().toISOString().substr(0, 10);
    this.form.checkInterval.next = new Date().toISOString().substr(0, 10);
    /* eslint-enable @typescript-eslint/no-magic-numbers */
    this.form.stamp = '';
    this.observer.reset();
  }

  private async dialogOpenHandler(): Promise<void> {
    this.observer.reset();
    this.clearForm();

    await Promise.all([
      this.fetchResources(),
      this.fetchModels()
    ]);
  }

  private async create(): Promise<void> {
    this.observer.reset();

    if (await this.observer.validate()) {
      return await this.createCounter(this.form);
    } else {
      throw new Error('Validation error');
    }
  }
}
